import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app';
import { appConfig } from './app/app.config';

registerLocaleData(localeDe);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
